<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Don was lucky enough to be offered a seven-year apprenticeship with Chadburns, a company producing ship’s telegraphs and other maritime equipment.</p>
<p>While serving his apprenticeship and later as a designer draughtsman, Don spent nine years attending night schools. At the end of the ninth year, he had been awarded, in the field of Mechanical Engineering, a Pre-National Certificate, an Ordinary National Certificate, a Higher National Certificate, and he had passed all of the extra subjects required by the Institute of Mechanical Engineers. Don was accepted as a Graduate Member of the Institute of Mechanical Engineers and later as an Associate Member of the Institute of Mechanical Engineers.</p>
<p>After a number of years working as a designer, he decided to make a career change. After completing a full year’s course in Technical Teaching, in Bolton, Don started out on what was to be his main interest for a major part of his working life. Don spent nineteen years developing courses and teaching in the UK, Bermuda, Saudi Arabia, Bahrain and Algeria.</p>
<p>He believes that his most productive years were spent in Saudi Arabia, where he had the academic rank of Associate Professor, and where he was the Director of the university’s engineering laboratories. On his return to the UK in 1978, Don discovered that the number of apprenticeships in the engineering industry had decreased dramatically and there were few courses being offered for their advancement. He decided to make another career change. After a full year’s course on Technical Authorship in 1987, Don set off on a new, challenging and rewarding career. Writing technical documentation for companies such as Shell UK, Shell International, Heinz Foods Ltd, and British Nuclear Fuels kept him busy for a further 12 years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?43eb56e6